import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Trophy } from "lucide-react";
import { API, errText } from "@/lib/auth";
import { money } from "@/components/market/Shared";
import { cents } from "@/components/predict/utils";
import { RealSwitch } from "./RealSwitch";

export const PicksRealCard = () => {
  const [bot, setBot] = useState(null);
  const [real, setReal] = useState(null);
  const load = () => {
    axios.get(`${API}/predict/bot`).then((r) => setBot(r.data)).catch(() => {});
    axios.get(`${API}/predict/real`).then((r) => setReal(r.data)).catch(() => {});
  };
  useEffect(() => { load(); const id = setInterval(load, 60000); return () => clearInterval(id); }, []);
  const set = async (on, confirm) => {
    try { await axios.post(`${API}/predict/bot/config`, { real: on, confirm }); toast.success(on ? "Picks bot now trades REAL money" : "Picks bot back on paper"); load(); }
    catch (e) { toast.error(errText(e)); }
  };
  if (!bot) return null;
  const on = bot.config.real;
  return (
    <section className={`glass p-5 space-y-4 ${on ? "ring-1 ring-amber-400/50" : ""}`} data-testid="picks-real-card">
      <div className="flex items-start justify-between gap-3">
        <div><h2 className="font-head font-bold text-lg flex items-center gap-2"><Trophy className="w-5 h-5 text-[var(--violet)]" />Data-picks bot · sports & all markets</h2>
          <p className="text-xs text-slate-400 mt-1 max-w-xl">Every 10 minutes buys the top data pick in each category on Polymarket US and holds it to settlement. Paper results always tracked below on the Predict page.</p></div>
        <RealSwitch on={on} onChange={set} testid="picks-real-switch" what="The data-picks bot" />
      </div>
      {real && <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 text-xs font-num" data-testid="picks-real-stats">
        {[["Buying power", money(real.buying_power, 2)], ["Next bet size", real.next_stake ? money(real.next_stake, 0) : "needs ≥ $1"],
          ["Sizing", `${real.stake_pct}% of balance`], ["Real orders today", `${real.today} / ${real.max_trades_per_day}`]].map(([k, v]) => (
          <div key={k} className="rounded-xl bg-white/[0.03] border border-[var(--line)] p-2.5"><div className="text-[10px] uppercase tracking-wider text-slate-500">{k}</div><div className="mt-1 text-sm">{v}</div></div>))}
      </div>}
      {bot.real_error && on && <p className="text-xs text-amber-200" data-testid="picks-real-error">{bot.real_error}</p>}
      {real?.orders?.length > 0 && <div className="divide-y divide-[var(--line)] text-sm" data-testid="real-orders">
        {real.orders.slice(0, 8).map((o) => (
          <div key={o.order_id || o.opened_at} className="py-2 flex justify-between gap-3">
            <div className="min-w-0"><div className="truncate">{o.label}</div><div className="text-[11px] text-slate-500 font-num">{o.contracts} × {o.side_name} @ {cents(o.pay_price)} · {o.source || "manual"} · {o.status}</div></div>
            <div className="font-num text-xs shrink-0">{money(o.cost, 2)}</div>
          </div>))}
      </div>}
    </section>
  );
};
